export const getStatusBooleanValue = status => status === 'passed' || status === 'not-applicable';
export const getStatusValue = status => status ? 'passed' : 'failed';
//# sourceMappingURL=get-status.js.map